var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { combine } from 'zustand/middleware';
import { ChatType, } from 'common/types/chat-types';
import { useChatsListStore } from '../../chats-list-service/service-store/service-store';
export var customActions = function (initialValues) {
    return combine(initialValues, function (setState) { return ({
        selectChatData: function (chat) {
            return setState(function (state) { return (__assign(__assign({}, state), { selectedChatId: chat.id, content: 'companion' in chat ? __assign(__assign({}, chat), { type: ChatType.DialogChat }) : __assign(__assign({}, chat), { type: ChatType.GroupChat }), isReadOnly: false, isExcluded: false })); });
        },
        setSelectedChatId: function (selectedChatId) {
            return setState(function (state) {
                var _a;
                return (__assign(__assign({}, state), { selectedChatId: selectedChatId, isReadOnly: state.selectedChatId === selectedChatId && state.isReadOnly, isExcluded: state.selectedChatId === selectedChatId && state.isExcluded, content: selectedChatId
                        ? (_a = useChatsListStore.getState().content.find(function (_a) {
                            var id = _a.id;
                            return id === selectedChatId;
                        })) !== null && _a !== void 0 ? _a : null
                        : null }));
            });
        },
        excludeSelectedChat: function (chatId) {
            return setState(function (state) {
                return state.selectedChatId === chatId && !state.isReadOnly ? __assign(__assign({}, state), { isReadOnly: true, isExcluded: true }) : state;
            });
        },
        leaveSelectedChat: function (chatId) {
            return setState(function (state) {
                return state.selectedChatId === chatId ? __assign(__assign({}, state), { isReadOnly: true, isExcluded: false }) : state;
            });
        },
    }); });
};
